export const cpfCnpjFormater = (value: string) => {
  if (!value) {
    return "Loja em Montagem";
  }
  const cleanedValue = value.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
  if (cleanedValue.length === 11) {
    return cleanedValue.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "$1.$2.$3-$4");
  }
  if (cleanedValue.length === 14) {
    return cleanedValue.replace(
      /^(.{2})(.{3})(.{3})(.{4})(.{2})$/,
      "$1.$2.$3/$4-$5"
    );
  }
  return cleanedValue;
};
